/**
 * Reusable card shell for the Panoramica widgets.
 * Keeps the dashboard visual language consistent across all overview tiles.
 */
export function OverviewCard({ title, icon: Icon, iconColor = "text-[#007AFF]", accent, children, action, testId }) {
  return (
    <div
      className="bg-[#0F0F0F] border border-[#1F1F1F] rounded-2xl p-4 sm:p-5 flex flex-col gap-3"
      data-testid={testId}
    >
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2.5">
          {Icon && (
            <div className={`w-8 h-8 rounded-lg bg-[#171717] flex items-center justify-center ${iconColor}`}>
              <Icon size={16} weight="duotone" />
            </div>
          )}
          <h3
            className="text-sm font-bold tracking-wider uppercase text-white"
            style={{ fontFamily: "Barlow Condensed, sans-serif", letterSpacing: "0.06em" }}
          >
            {title}
          </h3>
          {accent && (
            <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-[#007AFF]/10 text-[#007AFF] font-medium">
              {accent}
            </span>
          )}
        </div>
        {action}
      </div>
      <div className="text-sm text-zinc-300">{children}</div>
    </div>
  );
}

export function OverviewEmpty({ message }) {
  return <p className="text-xs text-zinc-500 italic">{message}</p>;
}
